import {
  useContext,
} from 'react';
import {Context} from '../contexts/WordList';
import {updateWord} from '../helpers/localApi';

export function useEditWord() {
  const [state, dispatch] = useContext(Context);
  const {language} = state;

  const editWord = async (selectedKey, wordEn, wordFa, mediaUrl, transliteration, sentences) => {
    if (wordEn !== undefined && wordFa !== undefined) {
      try {
        const updated = await updateWord({
          language,
          id: selectedKey,
          wordEn,
          wordFa,
          mediaUrl,
          transliteration,
          sentences,
        });

        dispatch({
          type: 'EDIT_WORD',
          payload: {
            key: updated.key,
            wordEn: updated.wordEn,
            wordFa: updated.wordFa,
            mediaUrl: updated.mediaUrl,
            transliteration: updated.transliteration,
            sentences: updated.sentences,
            tags: updated.tags,
          },
        });

        return updated;
      } catch (error) {
        console.error('Error updating word: ', error);
        throw error;
      }
    }

    return null;
  };

  return {editWord};
};
